export default __webpack_public_path__ + "static/media/logo.ea0327ff.png";